module.exports = __webpack_public_path__ + "static/media/status-success.2f48bfa3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/status-success.svg
// module id = 66
// module chunks = 0